<template>
    <div>
        <!--采购历史-->
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="供应商">
                            <Select v-model="sendData.customer" filterable style="width: 150px">
                                <Option value="" >全部</Option>
                                <Option :value="k.id" v-for="(k,v) in supplierList" v-if="k.isdel!=0" :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  label="单号">
                            <Input v-model="sendData.code" style="width: 150px" />
                            <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="2">
                    <Button type="primary" style="position: relative;top: -10px;right: 25px"  @click="$router.push({path:'/purchasea-tui'})"><Icon type="md-add" />添加采购单</Button>
                </Col>
            </Row>
        </header>
        <section>
            <Card class="historyItem" :dis-hover="false"
                  v-for="(item, index) in pageData"
                  :key="index"
                  @click.native="$router.push({path:'/historyDetail',query:{id:item.id}})">
                <p slot="title" style="color: #46bab2;">{{item.suppliername}}</p>
                <span slot="extra" v-show="item.inferiorFlag==0" class="typeitem">采购退换单</span>
                <span slot="extra" v-show="item.inferiorFlag==1" class="typeitem">采购残次品退换单</span>
                <ul class="type-content">
                    <li>  实收金额：￥{{item.money}} </li>
                    <li>  商品数量：{{item.total}} </li>
                    <li>  建立时间：{{item.time}} </li>
                    <li>  订单号码：{{item.purchasecode}} </li>
                </ul>
                <p class="ywy">业务员：{{item.adminName}}</p>
            </Card>
        </section>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                supplierList:[],//供应商
                //customerList:[],//客户列表
                //adminList:[],//员工列表
                pageData:{},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                sendData:{
                    customer:'',
                    // staff:'',
                    code:'',
                },
                page:{
                    total:0,
                    page:1,
                    rows:12
                }
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-30)
            this.valuedate[1] = this.nowTime
            this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            this.getSupplierList()
            //this.getAdminList()
        },
        watch: {
            'sendData.code': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
            'sendData.customer': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
        },
        methods: {
            //获取采购单
            getPurchaseList(page,rows,startTime,endTime){
                this.$Api.getPurchaseList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,
                    purchasecode:this.sendData.code,
                    supplierid:this.sendData.customer,
                    status:4
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.pageData = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            //供应商
            getSupplierList(){
                this.$Api.getSupplierList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.supplierList =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            modifyTime(time){
                this.valuedate[0]=time[0]
                this.valuedate[1]=time[1]
                this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
            onGongPageTotal(num){
                this.getPurchaseList(num,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
            searchCondition(){
                this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .historyItem{
        width: 450px;
        height: 240px;
        background-color: #ffffff;
        box-shadow: 0px 3px 10px 0px
        rgba(24, 54, 129, 0.14);
        border-radius: 10px;
        display: inline-block;
        margin: 18px;
        cursor: pointer;
        .typeitem{
            display: block;
            width: auto;
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background-color: #e5fff7;
            border-radius: 4px;
            border: solid 1px #46bab2;
            position: relative;
            top: -3px;
            right: -3px;
            color: #46bab2;
        }
        .type-content{
            li{
                height: 30px;
            }
        }
        .ywy{
            text-align: right;
            padding-top: 10px;
        }
    }
</style>